export default "__VITE_ASSET__C6qGCq7O__"